export default __webpack_public_path__ + "static/media/about4.37fe3f49.jpg";